import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';
import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import TimeZone from '../../request/Timezone';
import type { PagedSafetyEventsRequest, SafetyEventsReportRequest, SafetyEventsResponse } from './Types';

export class SafetyEventsRequester {
  private requester: Requester;

  private baseUrl: string;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
    this.baseUrl = '/analytics/v1';
  }

  public getSafetyEvents = async (request: PagedSafetyEventsRequest): Promise<SafetyEventsResponse> => {
    const requestData = {
      endpoint: `${this.baseUrl}/risk-events`,
      method: HttpMethod.POST,
      body: JSON.stringify(
        snakecaseKeys({
          ...request,
          timezone: TimeZone.getTimezone(),
        })
      ),
    };

    const response = await this.requester.request(requestData);
    return camelcaseKeys(response.data.data, { deep: true });
  };

  public requestSafetyEventsReport = async (request: SafetyEventsReportRequest): Promise<string> => {
    const requestData = {
      endpoint: `${this.baseUrl}/risk-events/report/mail`,
      method: HttpMethod.POST,
      body: JSON.stringify(
        snakecaseKeys({
          ...request,
          timezone: TimeZone.getTimezone(),
        })
      ),
    };

    const response = await this.requester.request(requestData);
    return response.data.data;
  };
}

export default SafetyEventsRequester;
